import { connect } from "react-redux";
import { completeCriteriaOnboarding } from "../../../../actions/user";
import StreamFilterOnboarding from "../StreamFilterOnboarding";

const actions = { completeCriteriaOnboarding };

export default connect(null, actions)(StreamFilterOnboarding);
